// This file is auto-generated by @hey-api/openapi-ts

export type AddChatMessageRes = {
  chat_id: string;
};

export type AnswerReq = {
  lang: Language;
  text: string;
};

export type AnswerToConversationRes = {
  chat: Array<OpenAiChatMessage_Output>;
  chat_id: string;
  errors: Array<UserErrors>;
  proper_sentences_res: ProperSentenceCheckRes | null;
};

export type AnswerToTextRes = {
  chat: Array<OpenAiChatMessage_Output>;
  chat_id: string;
  errors: Array<UserErrors>;
};

export enum AutoTextLangLevel {
  EASY = 'easy',
  MEDIUM = 'medium',
  HARD = 'hard'
}

export type AutoTextReq = {
  description?: string | null;
  include_words?: Array<string> | null;
  n_words?: number;
  lang_level?: AutoTextLangLevel;
};

export type AutoTextRes = {
  title: string;
  text: string;
};

export type Body__get_translations_v1_word_info_translations_post = {
  words: Array<string>;
  context_sentences?: Array<string> | null;
};

export type CategoryRes = {
  category_content: Array<string>;
};

export enum CategoryType {
  PHRASES = 'phrases',
  SIMPLE_TEXTS = 'simple_texts',
  SAYINGS = 'sayings',
  CONVERSATIONS = 'conversations',
  WRITE = 'write',
  COURSE = 'course'
}

export type CommonMistake = {
  mistake: string;
  correction: string;
  explanation: string;
};

export enum CommunicationBasics {
  GREETINGS = 'greetings',
  QUESTIONS = 'questions',
  EXPRESSIONS = 'expressions'
}

export type ConfigRes = {
  video_channels_def: {
    [key: string]: Array<VideoDef>;
  };
  be_version: string;
  languages: Array<Language>;
  language_codes: {
    [key: string]: string;
  };
  lang_code_to_verbose: {
    [key: string]: string;
  };
};

export type Conversation = {
  scenes: Array<ConversationScene>;
};

export type ConversationScene = {
  title: string;
  description: string;
  img_description?: string;
  type: ConversationType;
  person_a: string;
  person_b: string;
  description_of_person_a: string;
  description_of_person_b: string;
  conversation: Array<ConversationStep>;
  voice_type?: LangVoiceType;
};

export type ConversationStep = {
  content: string;
  person: string;
  task: string;
};

export enum ConversationType {
  INIT_STEP = 'init_step',
  TEXT_ONLY = 'text_only',
  AUDIO_ONLY = 'audio_only',
  CHAT = 'chat',
  CHAT_AUDIO = 'chat_audio',
  EMAIL = 'email'
}

export type CoreRule = {
  rule: string;
  explanation: string;
  usage_note?: string | null;
  rule_examples: Array<RuleExample>;
  common_mistakes?: Array<CommonMistake>;
  exceptions?: Array<string>;
  variations?: Array<string>;
};

export type CustomVocabularyReq = {
  title: string;
  description: string;
  n_words?: number;
  foreign: Language;
  native: Language;
};

export type CustomVocabularyRes = {
  words: Array<CustomVocabularyWord>;
};

export type CustomVocabularyWord = {
  word: string;
  translation: string;
};

export type DetectObjectsReq = {
  image: string;
};

export type EmailReq = {
  app_name: string;
  tier: string;
  env?: string | null;
  to?: Array<string> | null;
  subject: string;
  message: {
    [key: string]: unknown;
  };
};

export enum EntertainmentAndLeisure {
  ENTERTAINMENT = 'entertainment',
  LEISURE = 'leisure'
}

export type FeedArticle = {
  id: string;
  short_id: string;
  title: string;
  link: string;
  published_at: string;
  source_url: string;
  source: string;
  image_url?: string | null;
  topic?: GoogleRssTopic | null;
  created_summary?: string | null;
  created_content?: string | null;
  parsed_url: string;
};

export type FeedHeadline = {
  id: string;
  short_id: string;
  title: string;
  link: string;
  published_at: string;
  source_url: string;
  source: string;
  image_url?: string | null;
  topic?: GoogleRssTopic | null;
};

export enum FeelingsAndEmotions {
  POSITIVE_EMOTIONS = 'positive_emotions',
  NEGATIVE_EMOTIONS = 'negative_emotions',
  NEUTRAL_OR_MIXED_FEELINGS = 'neutral_or_mixed_feelings'
}

export enum FoodAndDining {
  FOOD = 'food',
  DRINKS = 'drinks',
  DINING = 'dining'
}

export enum GoogleRssTopic {
  WORLD = 'world',
  BUSINESS = 'business',
  TECHNOLOGY = 'technology',
  ENTERTAINMENT = 'entertainment',
  SCIENCE = 'science',
  SPORTS = 'sports',
  HEALTH = 'health',
  NATION = 'nation'
}

export type GrammarLessonRes = {
  title: string;
  short_description: string;
  detailed_explanation: string;
  core_rules: Array<CoreRule>;
  practice_section: Array<PracticeExercise>;
};

export type GrammerChapter = {
  chapter_number: string;
  title: string;
  description: string;
  sub_chapters: Array<GrammerChapter>;
};

export type GrammerMenuRes = {
  chapters: Array<GrammerChapter>;
};

export type HTTPValidationError = {
  detail?: Array<ValidationError>;
};

export enum HealthAndWellBeing {
  HEALTH = 'health',
  WELL_BEING = 'well_being'
}

export type HealthRes = {
  status?: string;
};

export type Joke = {
  text: string;
};

export type JokesResponse = {
  language: string;
  jokes: Array<Joke>;
};

export type KlexikonArticle = {
  title: string;
  title_de: string;
  teaser: string;
  paragraphs: Array<KlexikonParagraph>;
  image_url?: string | null;
};

export type KlexikonParagraph = {
  title?: string | null;
  content: string;
  image_urls?: Array<string>;
};

export type KlexikonTeaserRes = {
  title: string;
  title_de: string;
  teaser: string;
  image_url?: string | null;
};

export enum LangVoiceType {
  MAN = 'man',
  WOMAN = 'woman',
  GIRL = 'girl',
  BOY = 'boy',
  TAXIDRIVER = 'taxidriver',
  DOCTOR = 'doctor',
  LISA = 'lisa',
  TEACHER = 'teacher',
  MIKE = 'mike',
  WAITER = 'waiter',
  BOSS = 'boss'
}

export enum Language {
  DE = 'de',
  EN = 'en',
  ES = 'es',
  FR = 'fr',
  IT = 'it',
  PT = 'pt',
  RU = 'ru',
  PL = 'pl',
  ZH = 'zh'
}

export enum LanguageLevel {
  A1_A2 = 'A1-A2',
  B1_B2 = 'B1-B2',
  C1_C2 = 'C1-C2'
}

export type LiveConversationSummary = {
  id: string;
  title: string;
  description: string;
};

export type LiveConversationTranscript = {
  session_id: string;
  conversation_id: string;
  language: Language;
  status: string;
  started_at: string;
  ended_at?: string | null;
  turns?: Array<LiveConversationTurn>;
};

export type LiveConversationTurn = {
  role: string;
  content: string;
  errors?: Array<UserErrors>;
};

export type LoadCountsRes = {
  feeds: {
    [key: string]: number;
  };
  videos: {
    [key: string]: number;
  };
  klexikon: number;
};

export enum MainCategories {
  COMMUNICATION_BASICS = 'communication_basics',
  FEELINGS_AND_EMOTIONS = 'feelings_and_emotions',
  TRAVEL_AND_DIRECTIONS = 'travel_and_directions',
  NUMBERS_AND_QUANTITY = 'numbers_and_quantity',
  TIME_AND_DATES = 'time_and_dates',
  ENTERTAINMENT_AND_LEISURE = 'entertainment_and_leisure',
  HEALTH_AND_WELL_BEING = 'health_and_well_being',
  SOCIAL_CONTEXTS = 'social_contexts',
  FOOD_AND_DINING = 'food_and_dining'
}

export type MessageCheckForType = {
  content: string;
  type: OpenAiRoleType;
  value?: string | number | null;
  label: string;
};

export enum NubmersAndQuantity {
  NUMBERS = 'numbers',
  QUANTITY = 'quantity'
}

export type OpenAiChatMessage_Input = {
  role: OpenAiRoleType;
  content: string;
  check_for?: MessageCheckForType | null;
  on_success_sys_msg?: string | null;
  response_lang?: Language | null;
};

export type OpenAiChatMessage_Output = {
  role: OpenAiRoleType;
  content: string;
  check_for?: MessageCheckForType | null;
  on_success_sys_msg?: string | null;
  response_lang?: Language | null;
};

export enum OpenAiRoleType {
  SYSTEM = 'system',
  USER = 'user',
  ASSISTANT = 'assistant'
}

export type PracticeExercise = {
  prompt: string;
  correct_answer: string;
  wrong_answers: Array<string>;
};

export type ProperSentenceCheckRes = {
  is_proper_sentence: boolean;
  fullfills_task: boolean;
  description: string;
};

export type DeepgramSessionResponse = {
  access_token: string;
  expires_in: number;
};

export type RuleExample = {
  example: string;
  example_explanations: string;
};

export type SentencesWithWords = {
  sentence: string;
  words: Array<string>;
  image: string;
  voice?: string | null;
};

export enum SocialContexts {
  SOCIAL = 'social',
  CULTURAL = 'cultural',
  RELIGIOUS = 'religious',
  POLITICAL = 'political'
}

export type SplitSentenceRequest = {
  sentences: Array<string>;
};

export type StartLiveConversationRequest = {
  language: Language;
};

export type StartLiveConversationResponse = {
  session_id: string;
  livekit_url: string;
  livekit_token: string;
};

export type Story = {
  title: string;
  title_image: string;
  story: Array<SentencesWithWords>;
  train_sentences: Array<string>;
  train_questions: Array<TrainQuestion>;
};

export type SummarizeMistakesReq = {
  lang: Language;
  chat: Array<OpenAiChatMessage_Input>;
  errors: Array<UserErrors>;
};

export type SummarizeMistakesRes = {
  summary: string;
};

export enum TimeAndDates {
  TIME = 'time',
  DATES = 'dates'
}

export type TrainQuestion = {
  question: string;
  wrong_answers: Array<string>;
  right_answer: string;
};

export enum TravelAndDirections {
  DIRECTIONS = 'directions',
  LOCATIONS = 'locations',
  TRANSPORTATION = 'transportation',
  ACCOMODATION = 'accomodation'
}

export type UserErrors = {
  error: string;
  correction: string;
};

export type ValidationError = {
  loc: Array<string | number>;
  msg: string;
  type: string;
};

export type Video = {
  view_count: number;
  like_count?: number | null;
  id: string;
  title: string;
  description: string;
  published_at: string;
  channel_id: string;
  channel_title: string;
  thumbnail_url: string;
  transcript: Array<{
    [key: string]: unknown;
  }>;
};

export type VideoDef = {
  title: string;
  channel_id: string;
};

export enum VocabularyCategory {
  GREETINGS = 'greetings',
  NUMBERS = 'numbers',
  TIME = 'time',
  COLORS = 'colors',
  FAMILY = 'family',
  BODY = 'body',
  FOOD = 'food',
  DRINKS = 'drinks',
  CLOTHING = 'clothing',
  HOUSE = 'house',
  FURNITURE = 'furniture',
  NATURE = 'nature',
  ANIMALS = 'animals',
  WEATHER = 'weather',
  TRAVEL = 'travel',
  TRANSPORTATION = 'transportation',
  CITY = 'city',
  WORK = 'work',
  SCHOOL = 'school',
  HEALTH = 'health',
  EMOTIONS = 'emotions',
  SPORTS = 'sports',
  HOBBIES = 'hobbies',
  TECHNOLOGY = 'technology',
  SHOPPING = 'shopping',
  COMMUNICATION = 'communication',
  DIRECTION = 'direction',
  PEOPLE = 'people',
  DESCRIPTIONS = 'descriptions',
  OBJECTS = 'objects'
}

export type VocabularyResponse = {
  language: string;
  words: Array<VocabularyWord>;
};

export type VocabularyWord = {
  word: string;
  category: VocabularyCategory;
};

export type WordImageReq = {
  word: string;
  context_sentence: string;
  language: Language;
};

export type WordImageRes = {
  image: string;
};

export type WordsReq = {
  words: Array<string>;
};

export type WriteCorrectionReq = {
  task: string;
  subject: string;
  content: string;
  needs_to_contain: Array<string>;
};

export type WriteCorrectionRes = {
  overall_analysis: string;
  needs_to_contain_analysis: string;
  spelling_errors: string;
  grammar_errors: string;
  rate: number;
};

export type WriteEmailTask = {
  title: string;
  description: string;
  needs_to_contain: Array<string>;
  to: string;
  min_words: number;
};

export type GetHealthV1HealthGetResponse = HealthRes;

export type GetHealthV1HealthGetError = unknown;

export type GetTranslationsV1WordInfoTranslationsPostData = {
  body: Body__get_translations_v1_word_info_translations_post;
  query: {
    foreign: Language;
    native: Language;
  };
};

export type GetTranslationsV1WordInfoTranslationsPostResponse = unknown;

export type GetTranslationsV1WordInfoTranslationsPostError = HTTPValidationError;

export type GetTranslationSentencesV1WordInfoTranslationSentencesPostData = {
  body: Array<string>;
  query: {
    foreign: Language;
    native: Language;
  };
};

export type GetTranslationSentencesV1WordInfoTranslationSentencesPostResponse = unknown;

export type GetTranslationSentencesV1WordInfoTranslationSentencesPostError = HTTPValidationError;

export type GetTranslationV1WordInfoTranslationGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    index?: number | null;
    native: Language;
    q: string;
  };
};

export type GetTranslationV1WordInfoTranslationGetResponse = unknown;

export type GetTranslationV1WordInfoTranslationGetError = HTTPValidationError;

export type GetWordValidationV1WordInfoWordValidationGetData = {
  query: {
    foreign: Language;
    n?: number;
    q: string;
  };
};

export type GetWordValidationV1WordInfoWordValidationGetResponse = unknown;

export type GetWordValidationV1WordInfoWordValidationGetError = HTTPValidationError;

export type GetTranslationSentenceV1WordInfoTranslationSentenceGetData = {
  query: {
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetTranslationSentenceV1WordInfoTranslationSentenceGetResponse = unknown;

export type GetTranslationSentenceV1WordInfoTranslationSentenceGetError = HTTPValidationError;

export type GetImageV1WordInfoImageGetData = {
  query: {
    example: string;
    q: string;
  };
};

export type GetImageV1WordInfoImageGetResponse = unknown;

export type GetImageV1WordInfoImageGetError = HTTPValidationError;

export type GetExampleV1WordInfoExampleGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    q: string;
  };
};

export type GetExampleV1WordInfoExampleGetResponse = unknown;

export type GetExampleV1WordInfoExampleGetError = HTTPValidationError;

export type GetExamplesV1WordInfoExamplesGetData = {
  query: {
    context_sentence?: string | null;
    count?: number;
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetExamplesV1WordInfoExamplesGetResponse = unknown;

export type GetExamplesV1WordInfoExamplesGetError = HTTPValidationError;

export type GetEmotionalExamplesV1WordInfoEmotionalExamplesGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetEmotionalExamplesV1WordInfoEmotionalExamplesGetResponse = unknown;

export type GetEmotionalExamplesV1WordInfoEmotionalExamplesGetError = HTTPValidationError;

export type GetImagesUnsplashV1WordInfoImagesGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetImagesUnsplashV1WordInfoImagesGetResponse = unknown;

export type GetImagesUnsplashV1WordInfoImagesGetError = HTTPValidationError;

export type GetSynonymsV1WordInfoSynonymsGetData = {
  query: {
    foreign: Language;
    q: string;
  };
};

export type GetSynonymsV1WordInfoSynonymsGetResponse = unknown;

export type GetSynonymsV1WordInfoSynonymsGetError = HTTPValidationError;

export type GetAntonymsV1WordInfoAntonymsGetData = {
  query: {
    foreign: Language;
    q: string;
  };
};

export type GetAntonymsV1WordInfoAntonymsGetResponse = unknown;

export type GetAntonymsV1WordInfoAntonymsGetError = HTTPValidationError;

export type GetMainTranslationsV1WordInfoMainTranslationsGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q?: string | null;
    q_en?: string | null;
    translate_type: string;
    word_type?: string | null;
  };
};

export type GetMainTranslationsV1WordInfoMainTranslationsGetResponse = unknown;

export type GetMainTranslationsV1WordInfoMainTranslationsGetError = HTTPValidationError;

export type GetExtensionsV1WordInfoExtensionsGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q: string;
    q_en: string;
    word_type?: string | null;
  };
};

export type GetExtensionsV1WordInfoExtensionsGetResponse = unknown;

export type GetExtensionsV1WordInfoExtensionsGetError = HTTPValidationError;

export type GetMappingsV1WordInfoMappingsGetData = {
  query: {
    foreign_text: string;
    native: Language;
  };
};

export type GetMappingsV1WordInfoMappingsGetResponse = unknown;

export type GetMappingsV1WordInfoMappingsGetError = HTTPValidationError;

export type GetDefinitionV1WordInfoDefinitionGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetDefinitionV1WordInfoDefinitionGetResponse = unknown;

export type GetDefinitionV1WordInfoDefinitionGetError = HTTPValidationError;

export type GetBaseWordV1WordInfoBaseWordGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetBaseWordV1WordInfoBaseWordGetResponse = unknown;

export type GetBaseWordV1WordInfoBaseWordGetError = HTTPValidationError;

export type GetArticleV1WordInfoArticleGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetArticleV1WordInfoArticleGetResponse = unknown;

export type GetArticleV1WordInfoArticleGetError = HTTPValidationError;

export type GetConjugationsV1WordInfoConjugationsGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetConjugationsV1WordInfoConjugationsGetResponse = unknown;

export type GetConjugationsV1WordInfoConjugationsGetError = HTTPValidationError;

export type GetGrammerV1WordInfoGrammerGetData = {
  query: {
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetGrammerV1WordInfoGrammerGetResponse = unknown;

export type GetGrammerV1WordInfoGrammerGetError = HTTPValidationError;

export type GetGrammerWordV1WordInfoGrammerWordGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetGrammerWordV1WordInfoGrammerWordGetResponse = unknown;

export type GetGrammerWordV1WordInfoGrammerWordGetError = HTTPValidationError;

export type GetEtymologyV1WordInfoEtymologyGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetEtymologyV1WordInfoEtymologyGetResponse = unknown;

export type GetEtymologyV1WordInfoEtymologyGetError = HTTPValidationError;

export type GetAllMeaningsV1WordInfoAllMeaningsGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetAllMeaningsV1WordInfoAllMeaningsGetResponse = unknown;

export type GetAllMeaningsV1WordInfoAllMeaningsGetError = HTTPValidationError;

export type GetImageSentenceV1WordInfoImageSentenceGetData = {
  query: {
    foreign: Language;
    q: string;
  };
};

export type GetImageSentenceV1WordInfoImageSentenceGetResponse = unknown;

export type GetImageSentenceV1WordInfoImageSentenceGetError = HTTPValidationError;

export type GetMostCommonWordsV1WordInfoMostCommonWordsGetData = {
  body?: Array<string>;
  query: {
    foreign: Language;
    n?: number;
    q: string;
  };
};

export type GetMostCommonWordsV1WordInfoMostCommonWordsGetResponse = unknown;

export type GetMostCommonWordsV1WordInfoMostCommonWordsGetError = HTTPValidationError;

export type GetExampleSentenceV1WordInfoExampleSentencePostData = {
  body: WordsReq;
  query: {
    foreign: Language;
  };
};

export type GetExampleSentenceV1WordInfoExampleSentencePostResponse = unknown;

export type GetExampleSentenceV1WordInfoExampleSentencePostError = HTTPValidationError;

export type ReturnAudioFileV1FileAudioLangExtQgetData = {
  path: {
    ext: string;
    lang: Language;
    q: string;
  };
  query: {
    voice: LangVoiceType;
  };
};

export type ReturnAudioFileV1FileAudioLangExtQgetResponse = unknown;

export type ReturnAudioFileV1FileAudioLangExtQgetError = HTTPValidationError;

export type ReturnImageFileV1FileImageNameGetData = {
  path: {
    name: string;
  };
  query?: {
    dir?: string;
  };
};

export type ReturnImageFileV1FileImageNameGetResponse = unknown;

export type ReturnImageFileV1FileImageNameGetError = HTTPValidationError;

export type ReturnSoundFileV1FileSoundsNameGetData = {
  path: {
    name: string;
  };
};

export type ReturnSoundFileV1FileSoundsNameGetResponse = unknown;

export type ReturnSoundFileV1FileSoundsNameGetError = HTTPValidationError;

export type DeleteTtsFilesV1FileTtsLangDeleteData = {
  path: {
    lang: Language;
  };
};

export type DeleteTtsFilesV1FileTtsLangDeleteResponse = unknown;

export type DeleteTtsFilesV1FileTtsLangDeleteError = HTTPValidationError;

export type SplitChineseSentenceV1SentencesSplitChineseSentencePostData = {
  body: SplitSentenceRequest;
};

export type SplitChineseSentenceV1SentencesSplitChineseSentencePostResponse = unknown;

export type SplitChineseSentenceV1SentencesSplitChineseSentencePostError = HTTPValidationError;

export type GetConfigV1ConfigGetResponse = ConfigRes;

export type GetConfigV1ConfigGetError = unknown;

export type GetLoadCountsV1ConfigLoadCountsGetData = {
  query: {
    lang: Language;
    lang_level: LanguageLevel;
  };
};

export type GetLoadCountsV1ConfigLoadCountsGetResponse = LoadCountsRes;

export type GetLoadCountsV1ConfigLoadCountsGetError = HTTPValidationError;

export type GetFeedHealinesV1FeedsGetData = {
  query: {
    foreign: Language;
    lang_level: LanguageLevel;
    topic: GoogleRssTopic;
  };
};

export type GetFeedHealinesV1FeedsGetResponse = Array<FeedArticle>;

export type GetFeedHealinesV1FeedsGetError = HTTPValidationError;

export type SearchArticleV1FeedsSearchGetData = {
  query: {
    foreign: Language;
    lang_level: LanguageLevel;
    q: string;
    topic?: GoogleRssTopic | null;
  };
};

export type SearchArticleV1FeedsSearchGetResponse = Array<FeedArticle>;

export type SearchArticleV1FeedsSearchGetError = HTTPValidationError;

export type GetHeadlineByIdV1FeedsIdGetData = {
  path: {
    id: string;
  };
  query: {
    foreign: Language;
    lang_level: LanguageLevel;
    topic: GoogleRssTopic;
  };
};

export type GetHeadlineByIdV1FeedsIdGetResponse = FeedHeadline;

export type GetHeadlineByIdV1FeedsIdGetError = HTTPValidationError;

export type GetArticleV1FeedsSummaryTopicIdGetData = {
  path: {
    id: string;
    topic: GoogleRssTopic;
  };
  query: {
    foreign: Language;
    lang_level: LanguageLevel;
  };
};

export type GetArticleV1FeedsSummaryTopicIdGetResponse = FeedArticle;

export type GetArticleV1FeedsSummaryTopicIdGetError = HTTPValidationError;

export type GetVideoByIdxV1VideosChannelChannelIdGetData = {
  path: {
    channel_id: string;
  };
  query: {
    lang: Language;
    video_idx: number;
  };
};

export type GetVideoByIdxV1VideosChannelChannelIdGetResponse = Video;

export type GetVideoByIdxV1VideosChannelChannelIdGetError = HTTPValidationError;

export type GetVideoByIdV1VideosIdGetData = {
  path: {
    id: string;
  };
};

export type GetVideoByIdV1VideosIdGetResponse = Video;

export type GetVideoByIdV1VideosIdGetError = HTTPValidationError;

export type GetTeasersV1KlexikonTeasersGetData = {
  query: {
    lang: Language;
    n?: number;
  };
};

export type GetTeasersV1KlexikonTeasersGetResponse = Array<KlexikonTeaserRes>;

export type GetTeasersV1KlexikonTeasersGetError = HTTPValidationError;

export type SearchTeasersV1KlexikonTeasersSearchGetData = {
  query: {
    lang: Language;
    limit?: number;
    q: string;
  };
};

export type SearchTeasersV1KlexikonTeasersSearchGetResponse = Array<KlexikonTeaserRes>;

export type SearchTeasersV1KlexikonTeasersSearchGetError = HTTPValidationError;

export type GetArticleV1KlexikonArticlesTitleGetData = {
  path: {
    title: string;
  };
  query: {
    lang: Language;
  };
};

export type GetArticleV1KlexikonArticlesTitleGetResponse = KlexikonArticle;

export type GetArticleV1KlexikonArticlesTitleGetError = HTTPValidationError;

export type GetBooksListV1BooksListGetData = {
  query: {
    author_year_start?: number;
    languages: string;
    mime_type?: string;
    search?: string | null;
  };
};

export type GetBooksListV1BooksListGetResponse = unknown;

export type GetBooksListV1BooksListGetError = HTTPValidationError;

export type GetBookContentV1BooksContentBookUrlGetData = {
  path: {
    book_url: string;
  };
};

export type GetBookContentV1BooksContentBookUrlGetResponse = unknown;

export type GetBookContentV1BooksContentBookUrlGetError = HTTPValidationError;

export type AnswerToTextV1ChatAnswerToTextPostData = {
  body: AnswerReq;
  query?: {
    chat_id?: string | null;
  };
};

export type AnswerToTextV1ChatAnswerToTextPostResponse = AnswerToTextRes;

export type AnswerToTextV1ChatAnswerToTextPostError = HTTPValidationError;

export type AddChatMessageV1ChatAddChatMessagePostData = {
  body: Array<OpenAiChatMessage_Input>;
  query: {
    chat_id?: string | null;
    lang: Language;
  };
};

export type AddChatMessageV1ChatAddChatMessagePostResponse = AddChatMessageRes;

export type AddChatMessageV1ChatAddChatMessagePostError = HTTPValidationError;

export type AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostData = {
  body: AnswerReq;
  path: {
    category:
      | CommunicationBasics
      | FeelingsAndEmotions
      | TravelAndDirections
      | NubmersAndQuantity
      | TimeAndDates
      | EntertainmentAndLeisure
      | HealthAndWellBeing
      | SocialContexts
      | FoodAndDining;
    main_category: MainCategories;
  };
  query: {
    chat_id?: string | null;
    step_idx: number;
    user_step_idx: number;
  };
};

export type AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostResponse =
  AnswerToConversationRes;

export type AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostError =
  HTTPValidationError;

export type SummarizeMistakesV1ChatSummarizeMistakesPostData = {
  body: SummarizeMistakesReq;
};

export type SummarizeMistakesV1ChatSummarizeMistakesPostResponse = SummarizeMistakesRes;

export type SummarizeMistakesV1ChatSummarizeMistakesPostError = HTTPValidationError;

export type GetConversationsV1CategoryConversationsMainCategoryCategoryGetData = {
  path: {
    category:
      | CommunicationBasics
      | FeelingsAndEmotions
      | TravelAndDirections
      | NubmersAndQuantity
      | TimeAndDates
      | EntertainmentAndLeisure
      | HealthAndWellBeing
      | SocialContexts
      | FoodAndDining;
    main_category: MainCategories;
  };
  query: {
    lang: Language;
  };
};

export type GetConversationsV1CategoryConversationsMainCategoryCategoryGetResponse = Conversation;

export type GetConversationsV1CategoryConversationsMainCategoryCategoryGetError =
  HTTPValidationError;

export type GetWriteTaskV1CategoryWriteMainCategoryCategoryGetData = {
  path: {
    category:
      | CommunicationBasics
      | FeelingsAndEmotions
      | TravelAndDirections
      | NubmersAndQuantity
      | TimeAndDates
      | EntertainmentAndLeisure
      | HealthAndWellBeing
      | SocialContexts
      | FoodAndDining;
    main_category: MainCategories;
  };
  query: {
    lang: Language;
  };
};

export type GetWriteTaskV1CategoryWriteMainCategoryCategoryGetResponse = WriteEmailTask;

export type GetWriteTaskV1CategoryWriteMainCategoryCategoryGetError = HTTPValidationError;

export type GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetData = {
  path: {
    category:
      | CommunicationBasics
      | FeelingsAndEmotions
      | TravelAndDirections
      | NubmersAndQuantity
      | TimeAndDates
      | EntertainmentAndLeisure
      | HealthAndWellBeing
      | SocialContexts
      | FoodAndDining;
    category_type: CategoryType;
    main_category: MainCategories;
  };
  query: {
    lang: Language;
  };
};

export type GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetResponse = CategoryRes;

export type GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetError = HTTPValidationError;

export type SendEmailV1EmailSendPostData = {
  body: EmailReq;
};

export type SendEmailV1EmailSendPostResponse = unknown;

export type SendEmailV1EmailSendPostError = HTTPValidationError;

export type GetAutoTextV1AutoTextPostData = {
  body: AutoTextReq;
  query: {
    lang: Language;
  };
};

export type GetAutoTextV1AutoTextPostResponse = AutoTextRes;

export type GetAutoTextV1AutoTextPostError = HTTPValidationError;

export type GetTextCorrectionV1WriteCorrectPostData = {
  body: WriteCorrectionReq;
  query: {
    lang: Language;
  };
};

export type GetTextCorrectionV1WriteCorrectPostResponse = WriteCorrectionRes;

export type GetTextCorrectionV1WriteCorrectPostError = HTTPValidationError;

export type GenTtsV1GenTtsGetData = {
  query: {
    filename: string;
    lang: Language;
    text?: string | null;
    voice?: LangVoiceType;
  };
};

export type GenTtsV1GenTtsGetResponse = unknown;

export type GenTtsV1GenTtsGetError = HTTPValidationError;

export type GetGrammarMenuV1GrammarMenuGetData = {
  query: {
    lang: Language;
    lang_level: LanguageLevel;
    target_lang: Language;
  };
};

export type GetGrammarMenuV1GrammarMenuGetResponse = GrammerMenuRes;

export type GetGrammarMenuV1GrammarMenuGetError = HTTPValidationError;

export type GetGrammarChapterV1GrammarChapterGetData = {
  query: {
    chapter_number: string;
    lang: Language;
    lang_level: LanguageLevel;
    target_lang: Language;
  };
};

export type GetGrammarChapterV1GrammarChapterGetResponse = GrammarLessonRes;

export type GetGrammarChapterV1GrammarChapterGetError = HTTPValidationError;

export type GetWordImageV1CourseWordImagePostData = {
  body: WordImageReq;
};

export type GetWordImageV1CourseWordImagePostResponse = WordImageRes;

export type GetWordImageV1CourseWordImagePostError = HTTPValidationError;

export type GetShortStoriesV1CourseStoriesGetData = {
  query: {
    language: Language;
    language_level: LanguageLevel;
  };
};

export type GetShortStoriesV1CourseStoriesGetResponse = Array<Story>;

export type GetShortStoriesV1CourseStoriesGetError = HTTPValidationError;

export type GetFunFactsV1FunFactsLangForeignGetData = {
  path: {
    lang_foreign: string;
  };
};

export type GetFunFactsV1FunFactsLangForeignGetResponse = {
  [key: string]: unknown;
};

export type GetFunFactsV1FunFactsLangForeignGetError = HTTPValidationError;

export type GetVocabularyV1VocabularyGetData = {
  query: {
    language: Language;
  };
};

export type GetVocabularyV1VocabularyGetResponse = VocabularyResponse;

export type GetVocabularyV1VocabularyGetError = HTTPValidationError;

export type PostCustomVocabularyV1CustomVocabularyPostData = {
  body: CustomVocabularyReq;
};

export type PostCustomVocabularyV1CustomVocabularyPostResponse = CustomVocabularyRes;

export type PostCustomVocabularyV1CustomVocabularyPostError = HTTPValidationError;

export type GetJokesV1JokesGetData = {
  query: {
    language: Language;
  };
};

export type GetJokesV1JokesGetResponse = JokesResponse;

export type GetJokesV1JokesGetError = HTTPValidationError;

export type GetLiveConversationsV1LiveConversationsGetResponse = Array<LiveConversationSummary>;

export type GetLiveConversationsV1LiveConversationsGetError = unknown;

export type GetLiveConversationByIdV1LiveConversationsConversationIdGetData = {
  path: {
    conversation_id: string;
  };
};

export type GetLiveConversationByIdV1LiveConversationsConversationIdGetResponse =
  LiveConversationSummary;

export type GetLiveConversationByIdV1LiveConversationsConversationIdGetError = HTTPValidationError;

export type StartLiveConversationV1LiveConversationsConversationIdStartPostData = {
  body: StartLiveConversationRequest;
  path: {
    conversation_id: string;
  };
};

export type StartLiveConversationV1LiveConversationsConversationIdStartPostResponse =
  StartLiveConversationResponse;

export type StartLiveConversationV1LiveConversationsConversationIdStartPostError =
  HTTPValidationError;

export type GetLiveConversationSessionV1LiveConversationsSessionsSessionIdGetData = {
  path: {
    session_id: string;
  };
};

export type GetLiveConversationSessionV1LiveConversationsSessionsSessionIdGetResponse =
  LiveConversationTranscript;

export type GetLiveConversationSessionV1LiveConversationsSessionsSessionIdGetError =
  HTTPValidationError;

export type CreateSessionV1TranscriptionSessionPostData = Record<string, never>;

export type CreateSessionV1TranscriptionSessionPostResponse = DeepgramSessionResponse;

export type CreateSessionV1TranscriptionSessionPostError = unknown;

export type DetectObjectsV1VideoObjectDetectionDetectPostData = {
  body: DetectObjectsReq;
};

export type DetectObjectsV1VideoObjectDetectionDetectPostResponse = unknown;

export type DetectObjectsV1VideoObjectDetectionDetectPostError = HTTPValidationError;
